/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { Container, Slide } from './styles';

import draDebora from '~/assets/tv/doctors/dra-debora.png';
import draMichelle from '~/assets/tv/doctors/dra-michelle.png';
import draIsabela from '~/assets/tv/doctors/dra-isabela.png';
import draIvani from '~/assets/tv/doctors/dra-ivani.png';

interface IDoctors {
  show: boolean;
  startAnim: boolean;
}

interface ISlide {
  slide: string;
  slideTime: number;
  beforeTime?: number;
  afterTime?: number;
  bgSlide?: string;
}

const Doctors: React.FC<IDoctors> = ({ show, startAnim }) => {
  const [slideSelected, setSlideSelected] = useState({} as ISlide);
  const [showBefore, setShowBefore] = useState('');
  const [animSlideSelected, setAnimSlideSelected] = useState('');
  const [endAnimSlideSelected, setEndAnimSlideSelected] = useState('');

  const slides = useMemo<ISlide[]>(
    () => [
      { slide: 'Slide1', slideTime: 10000 },
      { slide: 'Slide2', slideTime: 10000 },
      { slide: 'Slide3', slideTime: 10000 },
      { slide: 'Slide4', slideTime: 10000 },
    ],
    []
  );

  const changeSlide = useCallback(
    (index) => {
      const { slide, slideTime } = slides[index];

      if (slides[index + 1] && slides[index + 1].beforeTime) {
        const nextSlide = slides[index + 1];
        if (nextSlide.beforeTime)
          setTimeout(() => {
            setShowBefore(nextSlide.slide);
            setAnimSlideSelected(nextSlide.slide);
          }, slideTime - nextSlide.beforeTime);
      }

      if (slides[index - 1] && slides[index - 1].afterTime) {
        const prevSlide = slides[index - 1];
        if (prevSlide.afterTime) {
          setEndAnimSlideSelected(prevSlide.slide);
          setSlideSelected(slides[index]);
          setTimeout(() => {
            setShowBefore('');
            setEndAnimSlideSelected('');
          }, prevSlide.afterTime);
        }
      } else {
        setSlideSelected(slides[index]);
      }
      setTimeout(() => {
        setAnimSlideSelected(slide);
        if (index + 1 < slides.length) {
          setTimeout(() => {
            changeSlide(index + 1);
          }, slideTime);
        } else {
          setTimeout(() => {
            setSlideSelected({} as ISlide);
          }, slideTime);
        }
      }, 100);
    },
    [slides]
  );

  useEffect(() => {
    if (show) {
      changeSlide(0);
    }
  }, [changeSlide, show]);

  return (
    <Container show={show} startAnim={startAnim}>
      <Slide
        show={slideSelected.slide === 'Slide1'}
        startAnim={slideSelected.slide === 'Slide1'}
        notShow={slideSelected.slide !== 'Slide1'}
      >
        <div className="slide-container">
          <p className="title">Conheça nossos especialistas</p>
          <p className="name">Dra. Debora</p>
          <p className="content">
            Especialista em Endodontia pela IOA INSTITUTO ODONTOLÓGICO DAS
            AMÉRICAS
          </p>
          <img src={draDebora} alt="Dra. Debora" className="doctor" />
        </div>
      </Slide>
      <Slide
        show={slideSelected.slide === 'Slide2'}
        startAnim={slideSelected.slide === 'Slide2'}
        notShow={slideSelected.slide !== 'Slide2'}
      >
        <div className="slide-container">
          <p className="title">Conheça nossos especialistas</p>
          <p className="name">Dra. Michelle</p>
          <p className="content">Dentistica, estética dental</p>
          <img src={draMichelle} alt="Dra. Michelle" className="doctor" />
        </div>
      </Slide>
      <Slide
        show={slideSelected.slide === 'Slide3'}
        startAnim={slideSelected.slide === 'Slide3'}
        notShow={slideSelected.slide !== 'Slide3'}
      >
        <div className="slide-container">
          <p className="title">Conheça nossos especialistas</p>
          <p className="name">Dra. Isabela</p>
          <p className="content">Odontopediatria, clínico geral</p>
          <img src={draIsabela} alt="Dra. Isabela" className="doctor" />
        </div>
      </Slide>
      <Slide
        show={slideSelected.slide === 'Slide4'}
        startAnim={slideSelected.slide === 'Slide4'}
        notShow={slideSelected.slide !== 'Slide4'}
      >
        <div className="slide-container">
          <p className="title">Conheça nossos especialistas</p>
          <p className="name">Dra. Ivani</p>
          <p className="content">Implantodontista e Diretora Técnica</p>
          <img src={draIvani} alt="Dra. Ivani" className="doctor" />
        </div>
      </Slide>
    </Container>
  );
};

export default Doctors;
